<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Parent Integration Management'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="table-form-container" [ngClass]="container_theme()">
    <app-aw-date-form
      [title]="'Filter by Date Created'"
      (dateSelected)="onDateSelected($event)"
      [required]="false"
    >
    </app-aw-date-form>
  </div>

  <aw-dialog
    [visible]="openDeleteDialog"
    [dialogOptions]="dialogOptionsDelete"
    (primaryAction)="dialogFormDeleteHandler($event)"
    (secondaryAction)="dialogCloseHandler()"
    ariaLabel="Delete parent integration"
  >
  </aw-dialog>
  
  <aw-table
    [columnsDefinition]="columnsDefinition"
    [tableData]="tableData()"
    [enableStickyOptions]="enableStickyOptions()"
    [sortDisabled]="sortDisabled()"
  >
  </aw-table>
</div>

@if (userPermissions['canCreate']) {
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
}
